"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Middleware_helpers_1 = require("../Middleware.helpers");
/**
 * @todo inject Immutable.js
 * @param action
 * @param authConfig
 * @param token
 */
var injectAuthToken = function (action, authConfig, token) {
    var _a;
    var options = action.options || {};
    var headers = options.headers || {};
    return __assign(__assign({}, action), { options: __assign(__assign({}, options), { headers: __assign(__assign({}, headers), (_a = {}, _a[authConfig.header] = "" + authConfig.prefix + token, _a)) }) });
};
/**
 * Http Auth Middleware will automatically inject an authorization token in all requests actions
 * @param authConfig
 */
var httpAuthMiddleware = function (authConfig) { return function () { return function (next) { return function (action) {
    var isQueryAction = Middleware_helpers_1.contains(authConfig.actions, action.type);
    var isByPass = Middleware_helpers_1.contains(authConfig.byPassQueries || [], action.queryKey);
    var token = isQueryAction && authConfig.getToken();
    // Inject auth token in all requests/mutations
    if (token && !isByPass) {
        return next(injectAuthToken(action, authConfig, token));
    }
    return next(action);
}; }; }; };
exports.default = httpAuthMiddleware;
//# sourceMappingURL=HttpAuthMiddleware.js.map